import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Layer, Source } from 'react-mapbox-gl'
import isEqual from 'deep-equal'
import diff from '../utility/diff'
import { makeGetLayerRendered } from '../selectors/layerRenderedSelector'
import { makeGetPaint } from '../selectors/paintSelector'
import { makeGetDatetime } from '../selectors/datetimeSelector'
import DataActions from '../redux/dataRedux'
import PlanetActions from '../redux/planetRedux'
import { makeGetEventData } from '../selectors/eventDataSelector'
import PlanetList from '../components/PlanetList'

const id = 'PlanetScope'
const authId = 'PipelinePlus'
const datetimeId = 'PipelineGreen'
const PLANET_API_KEY = 'c93217084d874198991837b45be28f49'

const query = () => {
  return (
    {"filter":{"type":"AndFilter","config":[{"type":"GeometryFilter","field_name":"geometry","config":{"type":"Polygon","coordinates":[[[-84.97607244920931,45.65612729107718],[-84.53581857905084,45.65612729107718],[-84.53581857905084,45.96792121553105],[-84.97607244920931,45.96792121553105],[-84.97607244920931,45.65612729107718]]]}},{"type":"OrFilter","config":[{"type":"AndFilter","config":[{"type":"StringInFilter","field_name":"item_type","config":["PSOrthoTile"]},{"type":"RangeFilter","field_name":"cloud_cover","config":{"gte":0,"lte":0.4}},{"type":"RangeFilter","field_name":"sun_elevation","config":{"gte":0,"lte":90}}]}]},{"type":"OrFilter","config":[{"type":"DateRangeFilter","field_name":"acquired","config":{"gte":"2018-10-11T12:05:45.082Z","lte":"2018-10-31T12:05:45.082Z"}}]}]},"item_types":["PSOrthoTile"]}
  )
}

function postData(url = ``, data = {}, method='POST', apiKey) {
  // Default options are marked with *
  return fetch(url, {
    method: method, // *GET, POST, PUT, DELETE, etc.
    mode: "cors", // no-cors, cors, *same-origin
    cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
    credentials: "same-origin", // include, same-origin, *omit
    // credentials: "include",
    headers: {
      // "Content-Type": "application/json; charset=utf-8",
      "content-type": "application/json",
      "Authorization": `api-key ${apiKey}`
    },
    redirect: "follow", // manual, *follow, error
    referrer: "no-referrer", // no-referrer, *client
    body: JSON.stringify(data), // body data type must match "Content-Type" header
  })
  // .then(response => response.json()); // parses response to JSON
}

const layout = {
  'line-cap': 'round'
}

export class PlanetLabs extends Component {
  async componentDidMount () {
    const { map } = this.context
    if (!map) { return }
    map.on('click', id, this.onClick)
  }

  componentWillUnmount () {
    const { map } = this.context
    if (!map) { return }
    map.off('click', id, this.handleMouseMove)
  }

  shouldComponentUpdate (nextProps) {
    if (nextProps.paint !== this.props.paint) {
      return false
    // } else if (nextProps.urls !== this.props.urls) {
    //   return true
    } else if (nextProps === this.props) {
      return false
    }

    return true
  }

  static contextTypes = {
    map: PropTypes.object
  }

  componentWillReceiveProps (props) {
    const { paint, layout, before, layerOptions, hovered } = this.props
    const { map } = this.context

    if (!isEqual(props.paint, paint)) {
      const paintDiff = diff(paint, props.paint)

      Object.keys(paintDiff).forEach(key => {
        map.getLayer(id) && map.setPaintProperty(id, key, paintDiff[key])
      })
    }

    if (!isEqual(props.layout, layout)) {
      const layoutDiff = diff(layout, props.layout)

      Object.keys(layoutDiff).forEach(key => {
        map.getLayer(id) && map.setLayoutProperty(id, key, layoutDiff[key])
      })
    }

    if (
      props.layerOptions &&
        layerOptions &&
        !isEqual(props.layerOptions.filter, layerOptions.filter)
    ) {
      map.setFilter(id, props.layerOptions.filter)
    }

    if (before !== props.before) {
      map.moveLayer(id, props.before)
    }
  }

  generateLayers(urls, paint) {
    return urls.map((url, index) => {
      const id = `PlanetLabs-${index}`

      return (
        <Fragment>
          <Source
            id={id}
            tileJsonSource={{
              type: 'raster',
              tiles: [url],
              tileSize: 512
            }}
            />
          <Layer
            type='raster'
            id={id}
            sourceId={id}
            paint={paint}
            onClick={() => console.log('clicked')}
            />
        </Fragment>
      )})
  }

  handleClick = (feature) => {
    const { actions } = this.props

    actions.planetUpdateUrls(feature)
  }

  onClick = (event) => {
    const { map } = this.context
    console.log('onclick')
  }

  render () {
    const { idToken, layerRendered, paint, time, urls } = this.props

    const visible = layerRendered
    const timeIso = time ? new Date(time).toISOString() : ''

    if (!visible) {
      return null
    }

    return (
      <Fragment>
        <PlanetList onClick={this.handleClick} />
        <Fragment>
          { urls && urls.length > 0 &&
              this.generateLayers(urls, paint)
            }
          }
        </Fragment>
      </Fragment>
    )
  }
}

const makeMapStateToProps = () => {
  const getLayerRendered = makeGetLayerRendered()
  const getPaint = makeGetPaint()
  const getDatetime = makeGetDatetime()
  const getEventData = makeGetEventData()
  const mapStateToProps = state => {
    return {
      idToken: state.login.idToken,
      layerRendered: getLayerRendered(
        state,
        id,
        authId
      ),
      paint: getPaint(state, id),
      time: state.layer.times[datetimeId] || undefined,
      datetime: getDatetime(state, id) || '',
      hovered: getEventData(state, id),
      urls: state.planet.urls
    }
  }
  return mapStateToProps
}

const mapDispatchToProps = dispatch => {
  return {
    actions: {
      dataUpdated: (json, event) =>
        dispatch(DataActions.dataFulfilled(json, id, event)),
      planetUpdateUrls: (feature) =>
        dispatch(PlanetActions.planetUpdateUrls(feature))
    }
  }
}

export default connect(makeMapStateToProps(), mapDispatchToProps)(PlanetLabs)



// WEBPACK FOOTER //
// ./src/layers/PlanetScope.js